import { useState } from "react";
import { Link } from "react-router-dom";
import { Building2, ArrowLeft } from "lucide-react";
import { API, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm fade-in">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-lg bg-blue-800 flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <h1 className="font-heading text-xl font-extrabold tracking-tight text-slate-900">Reimposta password</h1>
        </div>
        {done ? (
          <div data-testid="forgot-password-success">
            <p className="text-sm text-slate-600 mb-6">
              Se l'email è registrata, riceverai un link per reimpostare la password. Controlla la tua casella di posta.
            </p>
            <Link to="/login" className="text-sm text-blue-800 hover:underline flex items-center gap-1" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> Torna al login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email del tuo account</Label>
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@studio.it"
                data-testid="forgot-password-email-input"
              />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="forgot-password-error">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full bg-blue-800 hover:bg-blue-900" data-testid="forgot-password-submit-button">
              {loading ? "Invio..." : "Invia link di reset"}
            </Button>
            <Link to="/login" className="text-sm text-blue-800 hover:underline flex items-center gap-1 justify-center" data-testid="back-to-login-link">
              <ArrowLeft className="h-4 w-4" /> Torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
